import(/* webpackMode: "eager" */ "/home/anders/dev/presentgatan.se/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/anders/dev/presentgatan.se/src/app/components/Footer/footer.module.scss");
;
import(/* webpackMode: "eager" */ "/home/anders/dev/presentgatan.se/src/app/components/ProductPageGallery/product-page.module.scss");
;
import(/* webpackMode: "eager" */ "/home/anders/dev/presentgatan.se/src/app/(pages)/presenter/[slug]/slug-page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/anders/dev/presentgatan.se/src/app/components/Underline/underline.js");
